import {
  FeeKind,
  IMarketplacePayment,
  MarketplaceFeeItem,
} from 'shared/types/marketplacePayment';

export function mapUiFeeToItem(
  valor: number,
  tipo: FeeKind,
): MarketplaceFeeItem {
  return {
    driver: 'ITAU',
    method: 'PIX',
    feeValue: tipo === 'porcentagem' ? valor : 0,
    feeType: 'PERCENTAGE',
    transactionFeeValue: tipo === 'fixo' ? valor : 0,
    transactionFeeType: 'VALUE',
  };
}

export function buildUpdateFeesPayload(args: {
  customerId: number;
  idi: number;
  valor: number;
  tipo: FeeKind;
  oldValor: number;
  oldTipo: FeeKind;
}): IMarketplacePayment {
  return {
    customerId: args.customerId,
    idi: args.idi,
    marketplaceFees: [mapUiFeeToItem(args.valor, args.tipo)],
    marketplaceFeesOld: [mapUiFeeToItem(args.oldValor, args.oldTipo)],
  };
}

/** Aceita só dígitos e um separador decimal; máx. 1 antes e 2 depois (até `9,99`). */
export function sanitizeFreePixFeeInput(raw: string): string {
  const filtered = String(raw).replace(/[^\d.,]/g, '');
  const sepIndex = filtered.search(/[.,]/);

  if (sepIndex === -1) {
    return filtered.slice(0, 1);
  }

  const sep = filtered[sepIndex];
  const intPart = filtered.slice(0, sepIndex).replace(/\D/g, '').slice(0, 1);
  const decPart = filtered
    .slice(sepIndex + 1)
    .replace(/\D/g, '')
    .slice(0, 2);

  return `${intPart}${sep}${decPart}`;
}

/** Formata número da API para o input (sem máscara). */
export function formatFreePixFeeForInput(valor: number): string {
  if (!Number.isFinite(valor)) return '';
  return sanitizeFreePixFeeInput(String(valor));
}

export function isValidFreePixFee(
  valor: string,
  tipo: string,
): tipo is FeeKind {
  if (tipo !== 'porcentagem' && tipo !== 'fixo') {
    return false;
  }
  const trimmed = String(valor).trim();
  if (!trimmed) return false;
  // Máx. 1 dígito antes e 2 depois (até 9,99); rejeita letras / 12 / 1,234
  if (!/^\d([.,]\d{1,2})?$/.test(trimmed)) {
    return false;
  }
  const parsed = Number(trimmed.replace(',', '.'));
  return Number.isFinite(parsed);
}

export function parseFreePixFeeValue(valor: string): number {
  return Number(String(valor).trim().replace(',', '.'));
}
